import type { PaymentRepository } from '../../repositories/PaymentRepository';

export class ApprovePaymentFromSearchParamsUseCase {
  constructor(private readonly paymentRepository: PaymentRepository) {}

  async execute(searchParams: URLSearchParams): Promise<boolean> {
    return this.paymentRepository.approvePaymentFromSearchParams(searchParams);
  }
}
